import TileLayer from "ol/layer/Tile.js";
import WMTS from "ol/source/WMTS.js";
import WMTSTileGrid from "ol/tilegrid/WMTS.js";
import { get as getProjection } from "ol/proj.js";
import { getTopLeft, getWidth } from "ol/extent.js";

export const PNOA_WMTS_URL = "https://www.ign.es/wmts/pnoa-ma?";
export const PNOA_LAYER_ID = "OI.OrthoimageCoverage";
export const PNOA_TILE_MATRIX_SET = "GoogleMapsCompatible";
export const PNOA_PROJECTION = "EPSG:3857";
export const PNOA_FORMAT = "image/jpeg";
export const PNOA_MAX_ZOOM = 19;
export const PNOA_MATRIX_IDS = Object.freeze(
  Array.from({ length: PNOA_MAX_ZOOM + 1 }, (_, zoom) => String(zoom))
);

export const PNOA_ATTRIBUTION =
  '© <a href="https://www.ign.es/" target="_blank" rel="noopener noreferrer">Instituto Geográfico Nacional de España</a> · CC BY 4.0 scne.es';

const createPnoaTileGrid = (projection) => {
  const projectionExtent = projection.getExtent();
  const initialResolution = getWidth(projectionExtent) / 256;
  const resolutions = PNOA_MATRIX_IDS.map(
    (_, zoom) => initialResolution / 2 ** zoom
  );

  return new WMTSTileGrid({
    origin: getTopLeft(projectionExtent),
    resolutions,
    matrixIds: [...PNOA_MATRIX_IDS],
    tileSize: 256,
  });
};

export const createPnoaLayer = () => {
  const projection = getProjection(PNOA_PROJECTION);
  const source = new WMTS({
    attributions: PNOA_ATTRIBUTION,
    url: PNOA_WMTS_URL,
    layer: PNOA_LAYER_ID,
    matrixSet: PNOA_TILE_MATRIX_SET,
    format: PNOA_FORMAT,
    projection,
    requestEncoding: "KVP",
    style: "default",
    tileGrid: createPnoaTileGrid(projection),
    wrapX: false,
  });

  const layer = new TileLayer({
    source,
    visible: true,
    maxZoom: PNOA_MAX_ZOOM,
  });

  layer.setProperties({
    id: PNOA_LAYER_ID,
    title: "PNOA Máxima Actualidad",
  });

  return layer;
};
